// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReturnMailDetails
 */
export interface IReturnMailDetails {
    /**
     * 
     * @type {string}
     * @memberof IReturnMailDetails
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof IReturnMailDetails
     */
    original_mailing_type?: IReturnMailDetailsOriginalMailingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReturnMailDetails
     */
    resend_status?: IReturnMailDetailsResendStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IReturnMailDetails
     */
    processing_action?: IReturnMailDetailsProcessingActionEnum;
}

/**
* @export
* @enum {string}
*/
export enum IReturnMailDetailsOriginalMailingTypeEnum {
    WELCOME_LETTER = 'WELCOME_LETTER',
    ORPHAN_LETTER = 'ORPHAN_LETTER',
    STATEMENT = 'STATEMENT',
    TAX_FORM = 'TAX_FORM',
    UNKNOWN = 'UNKNOWN'
}
/**
* @export
* @enum {string}
*/
export enum IReturnMailDetailsResendStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    SKIPPED = 'SKIPPED'
}
/**
* @export
* @enum {string}
*/
export enum IReturnMailDetailsProcessingActionEnum {
    AUTO_PROCESS = 'AUTO_PROCESS',
    PROCESS = 'PROCESS',
    RESEND_ONLY = 'RESEND_ONLY'
}


/**
 * Check if a given object implements the IReturnMailDetails interface.
 */
export function instanceOfIReturnMailDetails(value: object): value is IReturnMailDetails {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function IReturnMailDetailsFromJSON(json: any): IReturnMailDetails {
    return IReturnMailDetailsFromJSONTyped(json, false);
}

export function IReturnMailDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReturnMailDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'original_mailing_type': json['original_mailing_type'] == null ? undefined : json['original_mailing_type'],
        'resend_status': json['resend_status'] == null ? undefined : json['resend_status'],
        'processing_action': json['processing_action'] == null ? undefined : json['processing_action'],
    };
}

export function IReturnMailDetailsToJSON(json: any): IReturnMailDetails {
    return IReturnMailDetailsToJSONTyped(json, false);
}

export function IReturnMailDetailsToJSONTyped(value?: IReturnMailDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'original_mailing_type': value['original_mailing_type'],
        'resend_status': value['resend_status'],
        'processing_action': value['processing_action'],
    };
}

